/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import { Form } from '@unform/web';
import { FiFilter } from 'react-icons/fi';
import Swal from 'sweetalert2';
import {
  FaChevronLeft,
  FaChevronRight,
  FaEllipsisH,
  FaEdit,
  FaExchangeAlt,
  FaLayerGroup,
  FaInfo,
} from 'react-icons/fa';
import Pagination from 'react-paginate';
import {
  Button,
  Card,
  Col,
  Row,
  Table,
  UncontrolledCollapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import { toast } from 'react-toastify';
import {
  Input,
  ReactSelectAsync,
  ReactSelectAsyncCreatable,
} from '../../components/unform/index';
import api from '../../services/api';
import { Translator } from '../../components/i18n';

function Safras({ idFazenda }) {
  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const talhoesDuplicados = Translator({
    path: 'talhoesDuplicados',
  });
  const formRefSafra = useRef();
  const formRefTalhoes = useRef();
  const formRefSafraEdit = useRef();

  const [safras, setSafras] = useState([]);
  const [talhoesSafra, setTalhoesSafra] = useState([]);
  const [culturas, setCulturas] = useState([]);
  const [filtro, setFiltro] = useState({
    status: 'A',
  });

  const [modalSafra, setModalSafra] = useState(false);
  const [selectedSafra, setSelectedSafra] = useState(null);

  const [safraTalhaoCultura, setSafraTalhaoCultura] = useState([]);

  const [modalSafraEdit, setModalSafraEdit] = useState(false);
  const [modalTalhoes, setModalTalhoes] = useState(false);
  const [modalTalhoesInfo, setModalTalhoesInfo] = useState(false);

  const toggleSafra = () => setModalSafra(!modalSafra);
  const toggleTalhoes = () => setModalTalhoes(!modalTalhoes);
  const toggleSafraEdit = () => setModalSafraEdit(!modalSafraEdit);
  const toggleTalhoesInfo = () => setModalTalhoesInfo(!modalTalhoesInfo);

  async function filtraTalhoesAsync(inputValue) {
    const { data } = await api.get(
      `/talhoes-async/${idFazenda}?descricao=${inputValue}`
    );

    return data.map((e) => ({ id: e.id, value: e.id, label: e.descricao }));
  }

  async function filtrarConsultaCulturaAsync(inputValue) {
    const { data } = await api.get(`/cultura?descricao=${inputValue}`);

    return data.map((e) => ({ value: e.id, label: e.descricao }));
  }

  const selectOptions = {};
  const optionsTalhoes = async (inputValue) =>
    await new Promise((resolve) => {
      clearTimeout(selectOptions);

      selectOptions.talhoes = setTimeout(() => {
        resolve(filtraTalhoesAsync(inputValue));
      }, 500);
    });
  const optionsCulturas = async (inputValue) =>
    await new Promise((resolve) => {
      clearTimeout(selectOptions);

      selectOptions.culturas = setTimeout(() => {
        resolve(filtrarConsultaCulturaAsync(inputValue));
      }, 500);
    });

  let timeoutConsulta;
  function filtrarConsulta(e, value) {
    setFiltro({ ...filtro, [value]: e, page: 1 });
  }

  const debounceConsulta = async (body, value) =>
    new Promise((resolve) => {
      clearTimeout(timeoutConsulta);

      timeoutConsulta = setTimeout(() => {
        resolve(filtrarConsulta(body, value));
      }, 500);
    });

  async function getSafras() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const params = Object.keys(filtro)
      .map((e) => {
        if (e === 'page') {
          if (Number.isNaN(filtro[e])) {
            return `${e}=${1}`;
          }
        }
        return `${e}=${filtro[e]}`;
      })
      .join('&');

    const { data } = await api.get(`/safras/${idFazenda}?${params}`);

    setSafras(data);
    window.scrollTo(0, 0);

    Swal.close();
  }

  useEffect(() => {
    getSafras();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro]);

  function formatDate(date) {
    if (date && date !== 'undefined') {
      const splittedDate = date.split('-');

      return `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;
    }
  }

  const handleSubmitSafra = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (
        !data[f] &&
        f !== 'complemento' &&
        !f.includes('talhoes_') &&
        f !== 'cep'
      ) {
        errors[f] = obrigatorio;
      }
    });

    formRefSafra.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        const talhoes = [];
        Object.keys(data).forEach((f) => {
          if (f.includes('talhoes_')) {
            const obj = f?.split('_');

            for (let index = 0; index < data[f].length; index += 1) {
              const talhao = data[f][index];

              if (talhoes.some((tal) => tal.id_talhao === talhao)) {
                throw toast.error(talhoesDuplicados);
              }

              talhoes.push({
                id_cultura: Number(obj[1]),
                id_talhao: talhao,
              });
            }
          }
        });

        data.id_fazenda = idFazenda;
        const { data: safraReturn } = await api.post('/safra', data);

        if (talhoes.length) {
          const newTalhoes = talhoes.map((obj) => ({
            ...obj,
            id_safra: safraReturn?.safra?.id,
          }));

          const body = {
            talhoes: newTalhoes,
          };

          await api.put(`/safra-talhao-edit/${safraReturn?.safra?.id}`, body);

          setCulturas([]);
        }
        toast.success(dadosSalvosSucesso);
        toggleSafra();
        getSafras();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const getInfosSafra = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/safra-info/${id}`);
      const { data: safraTC } = await api.get(`/safra-talhao-cultura/${id}`);

      setSelectedSafra(data?.safra);

      if (safraTC.length) {
        const group = safraTC.reduce((rv, x) => {
          (rv[x.id_cultura] = rv[x.id_cultura] || []).push(x);
          return rv;
        }, {});

        const res = Object.values(group).map((item) => ({
          value: item[0].Cultura?.value,
          label: item[0].Cultura?.label,
          items: item.map((m) => m.Talhao),
        }));

        setSafraTalhaoCultura(res);
      }
      toggleSafraEdit();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  const handleSubmitSafraEdit = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    formRefSafraEdit.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        const talhoes = [];
        Object.keys(data).forEach((f) => {
          if (f.includes('talhoes_')) {
            const obj = f?.split('_');

            for (let index = 0; index < data[f].length; index += 1) {
              const talhao = data[f][index];

              if (talhoes.some((tal) => tal.id_talhao === talhao)) {
                throw toast.error(talhoesDuplicados);
              }

              talhoes.push({
                id_cultura: Number(obj[1]),
                id_talhao: talhao,
                id_safra: selectedSafra?.id,
              });
            }
          }
        });

        const body = { talhoes, safra: data };

        await api.put(`/safra-talhao-edit/${selectedSafra?.id}`, body);
        toast.success(dadosSalvosSucesso);
        setSelectedSafra([]);
        setSafraTalhaoCultura([]);
        toggleSafraEdit();
        getSafras();
        Swal.close();
      } catch (err) {
        toast.error(err?.response?.data?.error || erroSalvarDados);
        Swal.close();
      }
    }
  };

  const ativaInativaSafra = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      await api.put(`/safra/${id}`);
      toast.success(dadosSalvosSucesso);
      getSafras();
      Swal.close();
    } catch (err) {
      toast.error(erroSalvarDados);
      Swal.close();
    }
  };

  const talhoesSafraEdit = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/safra-upload/${id}?defaultoption=N`);
      setTalhoesSafra(data?.talhoes);
      toggleTalhoes();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  const handleSubmitTalhao = async (data) => {
    const errors = {};

    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    formRefTalhoes.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const body = {
          object: data,
        };
        await api.put('/safra-talhao-edit', body);

        setTalhoesSafra([]);
        toggleTalhoes();
        toast.success(dadosSalvosSucesso);
        Swal.close();
      } catch (err) {
        toast.error(erroSalvarDados);
        Swal.close();
      }
    }
  };

  const verInfosTalhoes = async (id) => {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const { data } = await api.get(`/safra-upload/${id}?defaultoption=N`);

      setTalhoesSafra(data?.talhoes);
      toggleTalhoesInfo();
      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  async function handleAddCultura(descricao) {
    Swal.showLoading();
    try {
      const body = {
        descricao,
      };

      const { data } = await api.post('/cultura', body);

      const tipo = {
        value: data?.id,
        label: data?.descricao,
      };

      formRefSafra.current.setFieldValue('id_cultura', tipo);
      Swal.close();
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Erro ao salvar!');
      Swal.close();
    }
  }

  return (
    <>
      <Card>
        <div className="p-3 justify-content-between d-flex align-items-center">
          <Col lg={6}>
            <h6 className="txt-muted">
              <Translator path="excecoes.semregistros" /> {safras.total}
            </h6>
          </Col>
          <Col>
            <Button
              color="muted"
              id="toggler"
              className="d-flex align-items-center"
            >
              <FiFilter size={20} />
              &nbsp;&nbsp;
              <Translator path="usuarioadmin.filtros" />
            </Button>
          </Col>
          <div className="d-flex justify-content-center">
            <Button
              onClick={() => toggleSafra()}
              type="button"
              className="btn btn-primary ml-3"
            >
              <Translator path="fazenda.safratalhoescroqui.safras.btnnovasafra" />
            </Button>
          </div>
          <div className="d-flex justify-content-center" />
        </div>
        <div className="filter-collapse px-3 ">
          <UncontrolledCollapse toggler="#toggler" className="pb-3">
            <Row>
              <Col lg={3}>
                <Label>
                  <Translator path="fazenda.safratalhoescroqui.talhoes.descricao" />
                </Label>
                <input
                  onChange={(e) =>
                    debounceConsulta(e.target.value, 'descricao')
                  }
                  className="form-control"
                />
              </Col>
              <Col lg={3}>
                <Label>
                  <Translator path="fazenda.ativetalhoes.status" />
                </Label>
                <select
                  className="form-control"
                  onChange={(e) => debounceConsulta(e.target.value, 'status')}
                >
                  <option value="A">
                    {Translator({
                      path: 'fazenda.ativetalhoes.ativo',
                    })}
                  </option>
                  <option value="I">
                    {Translator({
                      path: 'fazenda.ativetalhoes.inativo',
                    })}
                  </option>
                  <option value="">
                    {Translator({
                      path: 'fazenda.ativetalhoes.todos',
                    })}
                  </option>
                </select>
              </Col>
            </Row>
          </UncontrolledCollapse>
        </div>

        <Table responsive>
          <thead>
            <tr>
              {/* <th>Fazenda</th> */}
              <th>
                <Translator path="fazenda.safratalhoescroqui.safras.verinfotalhoes.descricao" />
              </th>
              <th className="text-center">
                <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.datainicio" />
              </th>
              <th className="text-center">
                <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.datafim" />
              </th>
              <th>
                <Translator path="consultores.vincularfazenda.responsavel" />
              </th>
              <th className="text-center">
                <Translator path="consultores.editarconsultor.status" />
              </th>
              <th>
                <Translator path="consultores.vincularfazenda.acao" />
              </th>
            </tr>
          </thead>
          <tbody style={{ minHeight: '160px !important' }}>
            {safras?.safras?.length ? (
              safras.safras?.map((c) => (
                <tr key={c?.id}>
                  {/* <td>{c?.Fazenda?.nome}</td> */}
                  <td>{c?.descricao}</td>
                  <td className="text-center">
                    {c?.data_inicio && formatDate(c?.data_inicio)}
                  </td>
                  <td className="text-center">
                    {c?.data_termino && formatDate(c?.data_termino)}
                  </td>
                  <td>{c?.Fazenda?.responsavel}</td>
                  <td className="text-center">{c?.status}</td>
                  <td className="text-center">
                    <UncontrolledDropdown
                      size="xs"
                      style={{ position: 'absolute' }}
                    >
                      <DropdownToggle color="link link-gray" size="xs">
                        <FaEllipsisH size="1.3em" color="#43b02a" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem
                          onClick={() => getInfosSafra(c?.id)}
                          size="xs"
                        >
                          <FaEdit className="mr-1" size={18} />
                          <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.label" />
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => ativaInativaSafra(c?.id)}
                          size="xs"
                        >
                          <FaExchangeAlt className="mr-1" size={18} />
                          <Translator path="fazenda.safratalhoescroqui.safras.acao.ativarinativarsafra" />
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => verInfosTalhoes(c?.id)}
                          size="xs"
                        >
                          <FaInfo className="mr-1" size={18} />
                          <Translator path="fazenda.safratalhoescroqui.safras.acao.verinfotalhoes" />
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => talhoesSafraEdit(c?.id)}
                          size="xs"
                        >
                          <FaLayerGroup className="mr-1" size={18} />
                          <Translator path="fazenda.safratalhoescroqui.safras.acao.editartalhoessafra" />
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>
                  <Translator path="excecoes.semregistros" />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Pagination
          nextLabel={<FaChevronRight />}
          previousLabel={<FaChevronLeft />}
          pageCount={safras.pages || 1}
          onPageChange={({ selected }) =>
            setFiltro({ ...filtro, page: selected + 1 })
          }
          initialPage={0}
          containerClassName="pagination justify-end mr-1"
          activeClassName="active"
        />
      </Card>

      <Modal isOpen={modalSafra} toggle={toggleSafra} size="lg">
        <ModalHeader toggle={toggleSafra}>
          <Translator path="fazenda.safratalhoescroqui.safras.novasafra.label" />
        </ModalHeader>
        <Form ref={formRefSafra} onSubmit={(data) => handleSubmitSafra(data)}>
          <ModalBody>
            <Row>
              <Col lg={12}>
                <Input
                  name="descricao"
                  label={
                    <Translator path="fazenda.safratalhoescroqui.safras.novasafra.descricao" />
                  }
                  className="form-control"
                  type="text"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Input
                  name="data_inicio"
                  label={
                    <Translator path="fazenda.safratalhoescroqui.safras.novasafra.datainicio" />
                  }
                  className="form-control"
                  type="date"
                />
              </Col>
              <Col lg={6}>
                <Input
                  name="data_termino"
                  label={
                    <Translator path="fazenda.safratalhoescroqui.safras.novasafra.datatermino" />
                  }
                  className="form-control"
                  type="date"
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <ReactSelectAsyncCreatable
                  label={
                    <Translator path="fazenda.safratalhoescroqui.safras.novasafra.cultura" />
                  }
                  name="cultura"
                  isClearable
                  isMulti
                  cacheOptions
                  defaultOptions
                  loadOptions={optionsCulturas}
                  onChange={(e) => {
                    setCulturas(e);
                  }}
                  onCreateOption={handleAddCultura}
                />
              </Col>
            </Row>
            <br />
            {culturas.length ? (
              culturas.map((c) => (
                <Col lg={12}>
                  <Label>
                    <Translator path="fazenda.safratalhoescroqui.safras.novasafra.talhoes" />
                  </Label>
                  <ReactSelectAsync
                    label={`${c?.label}`}
                    name={`talhoes_${c?.value}`}
                    isClearable
                    isMulti
                    loadOptions={optionsTalhoes}
                  />
                  <br />
                </Col>
              ))
            ) : (
              <br />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalSafraEdit} toggle={toggleSafraEdit} size="lg">
        <ModalHeader toggle={toggleSafraEdit}>
          <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.label" />
        </ModalHeader>
        <Form
          ref={formRefSafraEdit}
          onSubmit={(data) => handleSubmitSafraEdit(data)}
        >
          <ModalBody>
            {selectedSafra && (
              <>
                <Row>
                  <Col lg={12}>
                    <Input
                      name="descricao"
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.descricao" />
                      }
                      className="form-control"
                      type="text"
                      defaultValue={selectedSafra?.descricao}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Input
                      name="data_inicio"
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.datainicio" />
                      }
                      className="form-control"
                      type="date"
                      defaultValue={selectedSafra?.data_inicio}
                    />
                  </Col>
                  <Col lg={6}>
                    <Input
                      name="data_termino"
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.datafim" />
                      }
                      className="form-control"
                      type="date"
                      defaultValue={selectedSafra?.data_termino}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <ReactSelectAsync
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.cultura" />
                      }
                      name="cultura"
                      isClearable
                      isMulti
                      loadOptions={optionsCulturas}
                      defaultValue={safraTalhaoCultura?.map((sftc) => ({
                        id: sftc?.value || null,
                        label: sftc?.label || 'Sem cultura',
                        value: sftc?.value || '',
                      }))}
                      onChange={(e) => {
                        setSafraTalhaoCultura(e);
                      }}
                    />
                  </Col>
                </Row>
                <br />
                {safraTalhaoCultura.length ? (
                  safraTalhaoCultura.map((c) => (
                    <Col lg={12}>
                      <Label>
                        <Translator path="fazenda.safratalhoescroqui.safras.novasafra.talhoes" />
                      </Label>
                      <ReactSelectAsync
                        label={c?.label || 'Sem cultura'}
                        name={`talhoes_${c?.value}`}
                        cache={false}
                        isClearable
                        isMulti
                        loadOptions={optionsTalhoes}
                        defaultValue={c?.items}
                      />
                      <br />
                    </Col>
                  ))
                ) : (
                  <br />
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalTalhoes} toggle={toggleTalhoes} size="lg">
        <ModalHeader toggle={toggleTalhoes}>
          <Translator path="fazenda.safratalhoescroqui.safras.editarsafratalhoes.label" />
        </ModalHeader>
        <Form
          ref={formRefTalhoes}
          onSubmit={(data) => handleSubmitTalhao(data)}
        >
          <ModalBody>
            {talhoesSafra?.length &&
              talhoesSafra?.map((c) => (
                <Row key={c?.safra_talhao?.id}>
                  <Col>
                    <Input
                      // eslint-disable-next-line prefer-template
                      name={'descricao_' + c?.value}
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.editarsafratalhoes.descricao" />
                      }
                      className="form-control"
                      type="text"
                      defaultValue={c?.label}
                    />
                  </Col>
                  <Col>
                    <ReactSelectAsync
                      label={
                        <Translator path="fazenda.safratalhoescroqui.safras.editarsafratalhoes.cultura" />
                      }
                      // eslint-disable-next-line prefer-template
                      name={'cultura_' + c?.safra_talhao?.id}
                      isClearable
                      loadOptions={optionsCulturas}
                      defaultValue={{
                        label: c?.safra_talhao?.Cultura?.descricao,
                        value: c?.safra_talhao?.id_cultura,
                      }}
                    />
                  </Col>
                </Row>
              ))}
          </ModalBody>
          <ModalFooter>
            <Button color="success" type="submit">
              <Translator path="botao.salvar" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modalTalhoesInfo} toggle={toggleTalhoesInfo} size="lg">
        <ModalHeader toggle={toggleTalhoesInfo}>
          <Translator path="fazenda.safratalhoescroqui.safras.editarsafra.talhoes" />
        </ModalHeader>
        <ModalBody>
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translator path="fazenda.safratalhoescroqui.safras.verinfotalhoes.descricao" />
                </th>
                <th className="text-center">
                  <Translator path="fazenda.safratalhoescroqui.safras.verinfotalhoes.cultura" />
                </th>
                <th className="text-center">
                  <Translator path="fazenda.safratalhoescroqui.safras.verinfotalhoes.tamanho" />
                </th>
                <th className="text-center">
                  <Translator path="fazenda.safratalhoescroqui.safras.verinfotalhoes.status" />
                </th>
              </tr>
            </thead>
            <tbody style={{ minHeight: '160px !important' }}>
              {talhoesSafra?.length ? (
                talhoesSafra?.map((c) => (
                  <tr key={c?.id}>
                    <td>{c?.talhao?.descricao}</td>
                    <td className="text-center">
                      {c?.safra_talhao?.Cultura?.descricao || null}
                    </td>
                    <td className="text-center">
                      {Number(c?.talhao?.tamanho)} h
                    </td>
                    <td className="text-center">{c?.talhao?.status}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Safras;
